import { CLINIC } from "@/lib/api";
import { Phone, CalendarClock } from "lucide-react";
import { Link } from "react-router-dom";

// Mobile-only sticky action bar.
// After introducing the floating WhatsApp FAB (WhatsAppFab.jsx), the mobile
// sticky bar keeps only two primary actions: "Sună acum" (blue) and
// "Programare" (elegant red). WhatsApp is handled by the FAB so it is not
// duplicated here. Two equal columns prevent horizontal scrolling on any
// mobile width.
export default function MobileStickyBar() {
  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-slate-200 backdrop-blur-xl bg-white/95"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      data-testid="mobile-sticky-bar"
    >
      <div className="grid grid-cols-2">
        <a
          href={CLINIC.phoneTel}
          className="py-3 flex flex-col items-center gap-1 text-white bg-[#0F2C59] active:bg-[#163d7a]"
          data-testid="sticky-call-btn"
        >
          <Phone className="w-5 h-5" />
          <span className="text-xs font-semibold">Sună acum</span>
        </a>
        <Link
          to="/contact#programare"
          className="py-3 flex flex-col items-center gap-1 text-white bg-[#B4262A] active:bg-[#8E1D20]"
          data-testid="sticky-appointment-btn"
        >
          <CalendarClock className="w-5 h-5" />
          <span className="text-xs font-semibold">Programare</span>
        </Link>
      </div>
    </div>
  );
}
